import React, { createContext, useState, useContext } from 'react';

const BottomScrollContext = createContext();

export const BottomScrollProvider = ({ children }) => {
  const [atBottom, setAtBottom] = useState({ bottom: 0, scrollHeight: 0 });

  return (
    <BottomScrollContext.Provider value={{ atBottom, setAtBottom }}>
      {children}
    </BottomScrollContext.Provider>
  );
};

export const useBottomScroll = () => {
  const context = useContext(BottomScrollContext);
  if (context === undefined) {
    throw new Error('useBottomScroll must be used within a BottomScrollProvider');
  }
  return context;
};
